module.exports = "/fonts/NeoSansStd-Light.woff?5312e648cb4bb05cfb9ae7b0043423e7";